/* unplugin-vue-components disabled */import script from "./SectsSkillEditCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SectsSkillEditCard.vue?vue&type=script&setup=true&lang=js"

import "./SectsSkillEditCard.vue?vue&type=style&index=0&id=b197e318&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b197e318"]])

export default __exports__